'use strict';

import Component from 'generic.basecomponent';
import menuManager from 'menu-manager';
import {MOBILE_MENU_ID} from '../../hamburger/js/generic.hamburger';

export default class DonateeMenu extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.container.addEventListener("click", this.toggle.bind(this));

        this.menu = document.querySelector('.js-donate-menu');
        this.menuId = 'donate';
        this.isOpened = false;


        menuManager.init(this.menuId, {
            default: {
                open: this.open.bind(this),
                close: this.close.bind(this),
                level: 1
            },
            desktop: {
                isEnabled: false
            }
        });

        this.isOpenedGlabally = null;
    }

    toggle() {
        if (this.isOpened) {
            //check if we opened helpline from page or from mobile menu
            if (this.isOpenedGlabally === true) {
                menuManager.close(this.menuId);
                menuManager.close(MOBILE_MENU_ID);
            } else {
                menuManager.close(this.menuId);
            }
        } else {
            if (menuManager.isOpened(MOBILE_MENU_ID)) {
                this.isOpenedGlabally = false;
            } else {
                //open mobile menu manually
                menuManager.open(MOBILE_MENU_ID);
                this.isOpenedGlabally = true;
            }
            menuManager.open(this.menuId);
        }
    }

    open() {
        this.isOpened = true;
        this.menu.classList.add("is-opened");
        this.container.classList.add("is-opened");
    }

    close() {
        this.isOpened = false;
        this.isOpenedGlabally = null;
        this.menu.classList.remove("is-opened");
        this.container.classList.remove("is-opened");
    }

}




// WEBPACK FOOTER //
// ./app/components/donate-menu/js/generic.donate-menu.js